import React, { lazy } from 'react';

// 面向机器人的页面
const RobotPage = lazy(() => import('@/pages/robot/robot'));
const SelectRobotModal = lazy(() => import('@/pages/robot/selectRobotModal'));
const LoginForRobot = lazy(() => import('@/pages/robot/robotLogin'));
const LoginForRobotByStdId = lazy(() => import('@/pages/robot/robotLoginByStdId'));
const CognitionRepeat = lazy(() => import('@/pages/robot/cognition/Repeat'));
const ClassifyRepeat = lazy(() => import('@/pages/robot/cognition/Classify'));
const TrainingReview = lazy(() => import('@/pages/robot/cognition/TrainingReview'));
const RepeatHistory = lazy(() => import('@/pages/robot/cognition/RepeatHistory'));
const RepeatHistoryDetail = lazy(() => import('@/pages/robot/cognition/RepeatHistoryDetail'));
const ClassifyHistory = lazy(() => import('@/pages/robot/cognition/ClassifyHistory'));
const ClassifyHistoryDetail = lazy(() => import('@/pages/robot/cognition/ClassifyHistoryDetail'));
// const LoginForRobot = lazy(() => import('@/pages/robot/robotLoginBack'));
const RegisterForRobot = lazy(() => import('@/pages/robot/robotRegister'));
const ConsultantAppointmentForRobot = lazy(() => import('@/pages/robot/ConsultantAppointment'));
const PsychologicalAIConsultant = lazy(() => import('@/pages/robot/PsychologicalAIConsultant'));
const PsychologicalAIConsultantWithFormTest = lazy(() => import('@/pages/robot/PsychologicalAIConsultantWithFormTest'));
const PsychologicalAIConsultantWithPrompt = lazy(() => import('@/pages/robot/PsychologicalAIConsultantWithPrompt'));
const PsychologicalTestForRobot = lazy(() => import('@/pages/robot/PsychologicalTest'));
const PsychologicalUserFormIframeForRobot = lazy(() => import('@/pages/robot/PsychologicalUserFormIframe'));
const PsychologicalSelfHelpForRobot = lazy(() => import('@/pages/robot/PsychologicalSelfHelp'));
const PsychologicalSelfHelpPlayerForRobot = lazy(() => import('@/pages/robot/PsychologicalSelfHelpPlayer'));
const PsychologicalTestReportListForRobot = lazy(() => import('@/pages/robot/PsychologicalTestReportList'));
const PsychologicalTestReportDetailForRobot = lazy(() => import('@/pages/robot/PsychologicalTestReportDetail'));
const LogoutForRobot = lazy(() => import('@/pages/robot/robotLogout'));
const RobotTestDance = lazy(() => import('@/pages/robot/RobotTestDance'));

const robotRoutes = [
  { path: '/client/robot/login', component: <LoginForRobot />, needInterceptor: false },
  { path: '/client/robot/login-std-id', component: <LoginForRobotByStdId />, needInterceptor: false },
  { path: '/client/robot/selectModal', component: <SelectRobotModal />, needInterceptor: true },
  // { path: '/client/robot/:loginType', component: <LoginForRobot />, needInterceptor: false },
  { path: '/client/robot/register/:authId', component: <RegisterForRobot />, needInterceptor: false },
  { path: '/client/robot/psychological-ai-consultant', component: <PsychologicalAIConsultant />, needInterceptor: true },
  { path: '/client/robot/psychological-ai-consultant-with-form-test', component: <PsychologicalAIConsultantWithFormTest />, needInterceptor: true },
  { path: '/client/robot/psychological-ai-consultant-with-prompt', component: <PsychologicalAIConsultantWithPrompt />, needInterceptor: true },
  {
    path: '/client/robot', component: <RobotPage />, needInterceptor: false,
    children: [
      { path: 'psychological-ai-consultant', component: <PsychologicalAIConsultant />, needInterceptor: true },
      { path: 'consultant-appointment', component: <ConsultantAppointmentForRobot />, needInterceptor: true },
      { path: 'psychological-test', component: <PsychologicalTestForRobot />, needInterceptor: true },
      { path: 'psychological-test-user-form', component: <PsychologicalUserFormIframeForRobot />, needInterceptor: true },
      { path: 'psychological-self-help', component: <PsychologicalSelfHelpForRobot />, needInterceptor: true },
      { path: 'psychological-self-help-player', component: <PsychologicalSelfHelpPlayerForRobot />, needInterceptor: true },
      { path: 'psychological-test-report', component: <PsychologicalTestReportListForRobot />, needInterceptor: true },
      { path: 'psychological-test-report-detail', component: <PsychologicalTestReportDetailForRobot />, needInterceptor: true },
      { path: 'logout', component: <LogoutForRobot />, needInterceptor: true },
    ]
  },
  { path: '/client/robot/cog-repeat', component: <CognitionRepeat />, needInterceptor: true },
  { path: '/client/robot/training-review', component: <TrainingReview />, needInterceptor: true },
  { path: '/client/robot/cog-classify', component: <ClassifyRepeat />, needInterceptor: true },
  { path: '/client/robot/repeat-history', component: <RepeatHistory />, needInterceptor: true },
  { path: '/client/robot/repeat-history-detail', component: <RepeatHistoryDetail />, needInterceptor: true },
  { path: '/client/robot/classify-history', component: <ClassifyHistory />, needInterceptor: true },
  { path: '/client/robot/classify-history-detail', component: <ClassifyHistoryDetail />, needInterceptor: true },
  { path: '/client/robot/test-dance', component: <RobotTestDance />, needInterceptor: false },
];

export default robotRoutes;
